// extracted by mini-css-extract-plugin
module.exports = {"quiz-result__product-grid--odd":"Quiz_quiz-result__product-grid--odd__KDelY"};